var m = require('mithril');
var prop = require('mithril/stream');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var presentation = require('./deviceDiscoveryPresentation');
var scPresentation = require('./scDiscoveryPresentation');

var discoveryModal = {};

function errorMessage(error) {
  if (!error) return 'BACnet/IP discovery failed.';
  if (typeof error === 'string') return error;
  return error.error || error.message || 'BACnet/IP discovery failed.';
}

function ridPath(recordOrRid, type) {
  var rid = recordOrRid && recordOrRid['@rid'] ? recordOrRid['@rid'] : recordOrRid;
  var text = String(rid || '');
  return text ? '/' + type + '/' + text.replace(/^#/, '') : '';
}

discoveryModal.open = function (server, onDone) {
  var lowLimit = prop('');
  var highLimit = prop('');
  var timeoutSeconds = prop('3');
  var running = prop(false);
  var error = prop('');
  var result = prop(null);

  function setButtons() {
    modal.vm.buttons([
      {
        label: 'Close',
        class: '',
        disabled: running,
        func: function () { modal.vm.close(); }
      },
      {
        label: running() ? 'Discovering…' : (result() ? 'Discover Again' : 'Discover'),
        class: 'btn-good',
        disabled: running,
        func: submit
      }
    ]);
  }

  function requestBody() {
    var body = { timeoutMs: Math.round(Number(timeoutSeconds()) * 1000) };
    if (String(lowLimit()).trim() || String(highLimit()).trim()) {
      body.lowLimit = lowLimit();
      body.highLimit = highLimit();
    }
    return body;
  }

  function submit() {
    if (running()) return;
    running(true);
    error('');
    result(null);
    setButtons();
    m.redraw();
    return loaders.requestWithLoader({
      url: '/api/v1/bacnetserver/' + String(server['@rid'] || '').replace(/^#/, '') + '/discover',
      method: 'POST',
      body: requestBody(),
      loader: 'submit'
    }).then(function (response) {
      result(response || { devices: [] });
      if (typeof onDone === 'function') onDone(response);
    }).catch(function (requestError) {
      error(errorMessage(requestError));
    }).finally(function () {
      running(false);
      setButtons();
      m.redraw();
    });
  }

  function resultTable(summary) {
    var devices = summary && summary.devices || [];
    if (!devices.length) return m('p.moon-gray', 'No devices responded during the discovery window.');
    return m('div.overflow-auto.mt3', { style: { maxHeight: '55vh' } }, [
      m('table.w-100.f5', { style: { minWidth: '1080px' } }, [
        m('thead', m('tr', [
          m('th.tl', 'Device'),
          m('th.tl', 'Source Network'),
          m('th.tl', 'Source Address'),
          m('th.tl', 'Address Bytes'),
          m('th.tl', 'Vendor ID'),
          m('th.tl', 'Maximum APDU'),
          m('th.tl', 'Segmentation'),
          m('th.tl', 'Result')
        ])),
        m('tbody', devices.map(function (device) {
          var hex = presentation.addressHex(device.address);
          var decoded = presentation.decodedAddress(device.address);
          return m('tr', [
            m('td.tl.nowrap', device.deviceRid
              ? m(m.route.Link, { href: ridPath(device.deviceRid, 'bacnetdevice') }, device.deviceName)
              : device.deviceName),
            m('td.tl.nowrap', device.network == null ? 'Direct' : device.network),
            m('td.tl.nowrap', decoded || m('span.moon-gray', '—')),
            m('td.tl.nowrap.mono', hex || m('span.moon-gray', '—')),
            m('td.tl.nowrap', presentation.numericLabel(device.vendorId)),
            m('td.tl.nowrap', presentation.numericLabel(device.maxApdu)),
            m('td.tl.nowrap', presentation.segmentationLabel(device.segmentation)),
            m('td.tl.nowrap', scPresentation.deviceActionLabel(device.action))
          ]);
        }))
      ])
    ]);
  }

  modal.vm.title('Discover BACnet/IP Devices');
  modal.vm.body = function () {
    var summary = result();
    return m('div', [
      m('p.mt0.moon-gray', [
        'Send a unicast BACnet Who-Is to ',
        m('span.mono', server.host + ':' + (server.destinationPort || server.port || 47808)),
        '. Direct and routed I-Am responses will be placed beneath this BACnet Host.'
      ]),
      error() ? m('div.red.mb3', error()) : null,
      m('form', { role: 'form', onsubmit: function (event) {
        event.preventDefault();
        submit();
      } }, [
        m('div.flex-ns', [
          m('div.form-group.w-third-ns.pr2-ns', [
            m('label', 'Low Device Instance'),
            m('input.form-control', {
              type: 'number', min: 0, max: 4194303, placeholder: 'All',
              value: lowLimit(), disabled: running(),
              oninput: function (event) { lowLimit(event.target.value); }
            })
          ]),
          m('div.form-group.w-third-ns.ph2-ns', [
            m('label', 'High Device Instance'),
            m('input.form-control', {
              type: 'number', min: 0, max: 4194303, placeholder: 'All',
              value: highLimit(), disabled: running(),
              oninput: function (event) { highLimit(event.target.value); }
            })
          ]),
          m('div.form-group.w-third-ns.pl2-ns', [
            m('label', 'Response Window (seconds)'),
            m('input.form-control', {
              type: 'number', min: 1, max: 15, step: 1,
              value: timeoutSeconds(), disabled: running(),
              oninput: function (event) { timeoutSeconds(event.target.value); }
            })
          ])
        ])
      ]),
      running() ? m('div.mv3.flex.items-center', [
        m('img.h1.mr2', { src: '/images/loading-bars.svg', alt: '' }),
        m('span', 'Listening for I-Am responses…')
      ]) : null,
      summary ? m('div.mt3', [
        m('div.f4', [
          (Number(summary.discovered) || 0) + ' discovered; ',
          (Number(summary.devicesCreated) || 0) + ' device' + (Number(summary.devicesCreated) === 1 ? '' : 's') + ' created; ',
          (Number(summary.devicesMatched) || 0) + ' matched.'
        ]),
        resultTable(summary)
      ]) : null
    ]);
  };
  setButtons();
  modal.vm.open({ extrawidth: true });
};

module.exports = discoveryModal;
